import './polyfills.ts';
import './rxjs-imports.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode }         from '@angular/core';
import { environment }            from './environments/environment';
import { AppModule }              from './app/';
import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
  enableProdMode();
}

datadogRum.init({
  applicationId: environment.datadog.applicationId,
  clientToken: environment.datadog.clientToken,
  site: environment.datadog.site,
  service: 'nomadic-admin-frontend',
  env: environment.datadog.env,
  trackInteractions: true,
  allowedTracingOrigins: [/^https:\/\/[^.]*\.(nomadic\.fm|staging\.nomadic\.fm|nomadic\.local)\//],
});

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/main.ts